import * as React from "react";
import {withStyles} from "@mui/styles";
import {actions as productsActions, selectors as productsSelectors} from "../../../Ducks/products";
import {actions as companiesActions, selectors as companiesSelectors} from "../../../Ducks/companies";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Grid} from "@mui/material";
import {useParams} from "react-router-dom";
import {selectors as accountSelectors} from "../../../Ducks/account";
import CircularProgress from "@mui/material/CircularProgress";
import ProductDetailsForm from "./ProductDetailsForm";
import ProductInformationForm from "./ProductInformationForm";
import ProductAdditionalForm from "./ProductAdditionalForm";
import {fetchGet, fetchPost} from "../../../API/util";

const useStyles = () => ({
    container: {
        textAlign: "left",
    },
});

class ProductDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedProduct: props.params.id,
            productColumns: [
                "product_id",
                "erp_client_division_id",
                "product_type_id",
                "country_id",
                "product_name",
                "product_external_name",
                "product_abbreviation",
                "product_description",
                "product_price_currency",
                "product_price",
                "product_location",
                "product_address",
                "product_zip_code",
                "product_city",
                "product_country",
                "product_region",
                "product_parking_info",
                "product_events_start",
                "product_events_stop",
                "product_show_on_website",
                "product_show_in_sales",
                "product_default_attendance_value",
                "product_website_description_short",
                "product_website_description_long",
                "product_last_modified",
                "product_group_id",
                "target_group_definition",
                "pains_gains",
                "thematics",
                "remarks",
                "countries.country_name",
                "product_types.product_type_name",
            ],
            productDetails: null,
            bookAssignments: [], // For ProductDetailsForm (IDs)
            bookAssignmentsData: [], // For ProductAdditionalForm (full book objects)
            bookAssignmentsLoading: false,
            bookAssignmentsError: null,
        };
    }

    componentDidMount() {
        this.getContactDetail();
        this.getProductTypesList();
        this.getCountryList();
        this.fetchBookAssignments();
    }

    getProductTypesList = () => {
        const {getProductTypes} = this.props;
        getProductTypes();
    };

    getCountryList = () => {
        const {getCountries} = this.props;
        getCountries();
    };

    getContactDetail = () => {
        const {getProductDetails} = this.props;
        const {selectedProduct, productColumns} = this.state;
        getProductDetails({id: selectedProduct, columns: productColumns});
    };

    fetchBookAssignments = () => {
        const {selectedProduct} = this.state;
        if (!selectedProduct) return;

        this.setState({bookAssignmentsLoading: true, bookAssignmentsError: null});

        fetchGet(`/products/${selectedProduct}/books`)
            .then((res) => {
                const assignments = res.data || [];
                const assignedIds = assignments.map((a) => a.book_id.toString());
                const assignedBooks = assignments.map((a) => ({
                    id: a.book.book_id.toString(),
                    title: a.book.title,
                    author: a.book.author,
                    isbn: a.book.isbn,
                }));
                this.setState({
                    bookAssignments: assignedIds,
                    bookAssignmentsData: assignedBooks,
                    bookAssignmentsLoading: false,
                });
            })
            .catch((err) => {
                this.setState({
                    bookAssignmentsError: err.message || "Failed to fetch book assignments",
                    bookAssignmentsLoading: false,
                });
            });
    };

    handleSaveBookAssignments = async (productId, bookIds) => {
        try {
            await fetchPost(`/products/${productId}/books`, {
                book_ids: bookIds.map((id) => parseInt(id)),
            });
            this.fetchBookAssignments();
        } catch (err) {
            throw err; // Let the child handle the error
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.productDetails !== this.props.productDetails) {
            this.setState({
                productDetails: this.props.productDetails && this.props.productDetails.main[0],
            });
        }
    }

    handleSaveClick = (obj) => {
        this.props.updateProduct({
            id: this.state.selectedProduct,
            obj: obj,
            key: Object.keys(obj)[0],
        });
    };

    render() {
        const {classes, countries, productTypes} = this.props;
        const {
            productDetails,
            bookAssignments,
            bookAssignmentsData,
            bookAssignmentsLoading,
            bookAssignmentsError,
        } = this.state;

        if (!productDetails) {
            return (
                <div style={{display: "flex", justifyContent: "center"}}>
                    <CircularProgress/>
                </div>
            );
        }

        return (
            <>
                {productDetails && countries && productTypes && (
                    <div className={classes.container}>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <ProductDetailsForm
                                    productDetails={productDetails}
                                    productTypes={productTypes}
                                    countries={countries}
                                    onClick={this.handleSaveClick}
                                    bookAssignments={bookAssignments}
                                    bookAssignmentsLoading={bookAssignmentsLoading}
                                    bookAssignmentsError={bookAssignmentsError}
                                    onSaveBookAssignments={this.handleSaveBookAssignments}
                                />
                                <ProductInformationForm
                                    productDetails={productDetails}
                                    onClick={this.handleSaveClick}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <ProductAdditionalForm
                                    productDetails={productDetails}
                                    onClick={this.handleSaveClick}
                                    bookAssignments={bookAssignmentsData}
                                    bookAssignmentsLoading={bookAssignmentsLoading}
                                    bookAssignmentsError={bookAssignmentsError}
                                />
                            </Grid>
                        </Grid>
                    </div>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    isLoading: productsSelectors.isLoading(state),
    user: accountSelectors.user(state),
    productDetails: productsSelectors.productDetails(state),
    countries: companiesSelectors.countries(state),
    productTypes: productsSelectors.productTypes(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getProductDetails: productsActions.getProductDetails,
            updateProduct: productsActions.updateProduct,
            getCountries: companiesActions.getCountries,
            getProductTypes: productsActions.getProductTypes,
        },
        dispatch
    );

function WithNavigate(props) {
    let params = useParams();
    return <ProductDetails {...props} params={params}/>;
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles)(WithNavigate));